import '../assets/scss/emotive.scss';
import '../components/Icon/library';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import LoginContainer from '../container/LoginContainer';

function bootstrap(element) {
  element.dataset.app = 'login';
  ReactDOM.render(<LoginContainer />, element);
}

export default bootstrap;
